export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    type: 'checkbox',
    width: 50,
    align: 'center',
    fixed: 'left',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_displaySampleName') || '样品名称',
    field: 'displaySampleName',
    minWidth: 220,
    headerAlign: 'left',
    fixed: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySampleName' },
  },
  {
    title: that.$l('table_label_sampleSetStatus') || '状态',
    width: 80,
    align: 'center',
    slots: { default: 'sampleSetStatus' },
  },
  {
    title: that.$l('table_label_category') || '套件分类',
    field: 'categoryFullName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSetSize') || '套件规格',
    field: 'sampleSetSize',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务员',
    field: 'salesPersonName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_designer') || '设计师',
    field: 'designerName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_sampleSource') || '样品来源',
    field: 'v_sampleSource',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '成品工厂',
    field: 'scmName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'scmName' },
  },
  {
    title: that.$l('table_label_costMainType') || '成本类型',
    field: 'v_costMainType',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_costPrice') || '成本价格',
    field: 'costPrice',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'costPrice' },
  },
  {
    title: that.$l('table_label_quotedMethod') || '报价方式',
    field: 'v_quotedMethod',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'quotedMethod' },
  },
  {
    title: that.$l('table_label_salesPrice') || '零售价',
    field: 'salesPrice',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displaySalesPrice' },
  },
  {
    title: that.$l('table_label_packageSize') || '包装尺寸',
    field: 'packageSize',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_packageMethod') || '包装方式',
    field: 'packageMethodName',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '客户',
    field: 'custName',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'custName' },
  },
  {
    title: that.$l('table_label_brand') || '品牌',
    field: 'brandName',
    align: 'left',
    minWidth: 220,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_create') || '创建人',
    field: 'createByName',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'createInfo' },
  },
  {
    title: that.$l('table_label_modify') || '修改人',
    field: 'modifyByName',
    align: 'left',
    width: 170,
    showHeaderOverflow: true,
    slots: { default: 'modifyInfo' },
  },
]
